import ReactModal from 'react-modal';
import { styled, css } from 'styled-components';
import { Media } from '../../../theme/Media';
import Typography from '../../Typography';
import { MODAL_TOP_OFFSET, MODAL_Z_INDEX, MODAL_BORDER_RADIUS, HEADER_MIN_HEIGHT, HEADER_MIN_HEIGHT_MOBILE, HEADER_PADDING, HEADER_PADDING_MOBILE, HEADER_TITLE_WRAPPER_GAP, BODY_PADDING, BODY_PADDING_MOBILE, FOOTER_MIN_HEIGHT, FOOTER_PADDING_VERTICAL, FOOTER_PADDING_HORIZONTAL, FOOTER_PADDING_MOBILE, FOOTER_BORDER_RADIUS, FOOTER_GAP, FOOTER_GAP_MOBILE, MODAL_PADDING, MODAL_PADDING_MOBILE, MODAL_TOP_OFFSET_MOBILE, } from './constants';
export const modalGlobalStyles = css `
  .ReactModal {
    &__Body--open {
      overflow: hidden;

      div[type='tooltip'][class*='Tooltip__Wrapper-'] {
        z-index: 2000;
      }
    }

    &__Overlay {
      padding: ${MODAL_TOP_OFFSET}px ${MODAL_PADDING}px ${MODAL_PADDING}px;
      opacity: 0;
      transition: opacity 0.3s;

      @media ${Media.xsMax} {
        padding: ${MODAL_TOP_OFFSET_MOBILE}px ${MODAL_PADDING_MOBILE}px ${MODAL_PADDING_MOBILE}px;
      }

      &--after-open {
        overflow: auto;
        opacity: 1;
      }

      &--before-close {
        opacity: 0;
      }
    }
  }
`;
export const StyledModal = styled(ReactModal) `
  &.ReactModal__Content {
    overflow: hidden;
    position: relative;
    height: ${({ height }) => height};
    max-width: 100%;
    width: ${({ width }) => width};
    outline: none;
    z-index: ${MODAL_Z_INDEX};
    display: flex;
    background-color: ${({ theme }) => theme.colors.grey00_1};
    margin: 0 auto;
    border-radius: ${MODAL_BORDER_RADIUS}px;
    ${({ theme }) => theme.shadows.medium}
    ${({ scroll }) => scroll &&
    css `
        max-height: 100%;
      `}
  }
`;
export const Wrapper = styled.div `
  width: 100%;
  display: flex;
  flex-direction: column;
`;
export const Header = styled.div `
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  width: 100%;
  min-height: ${HEADER_MIN_HEIGHT}px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey10_1};
  padding: ${HEADER_PADDING}px;

  @media ${Media.xsMax} {
    padding: ${HEADER_PADDING_MOBILE}px;
    min-height: ${HEADER_MIN_HEIGHT_MOBILE}px;
  }
`;
export const TitleWrapper = styled.div `
  display: flex;
  gap: ${HEADER_TITLE_WRAPPER_GAP}px;
`;
export const Title = styled(Typography.Title) `
  margin: 0;
  word-break: break-all;
`;
export const Body = styled.div `
  position: relative;
  padding: ${BODY_PADDING}px;
  flex: auto;
  overflow-y: auto;

  @media ${Media.xsMax} {
    padding: ${BODY_PADDING_MOBILE}px;
  }

  & + & {
    border-top: 1px solid ${({ theme }) => theme.colors.grey10_1};
  }
`;
export const Footer = styled.div `
  flex-shrink: 0;
  min-height: ${FOOTER_MIN_HEIGHT}px;
  background: ${({ theme }) => theme.colors.grey01_1};
  border-top: 1px solid ${({ theme }) => theme.colors.grey10_1};
  border-bottom-left-radius: ${FOOTER_BORDER_RADIUS}px;
  border-bottom-right-radius: ${FOOTER_BORDER_RADIUS}px;
  padding: ${FOOTER_PADDING_VERTICAL}px ${FOOTER_PADDING_HORIZONTAL}px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${FOOTER_GAP}px;

  @media ${Media.xsMax} {
    padding: ${FOOTER_PADDING_MOBILE}px;
    gap: ${FOOTER_GAP_MOBILE}px;
  }
`;
